import { Flex, Text, Box } from "rebass/styled-components";
import Icon from "./Icon";
import Button from "./Button";
import { optionsGridStyles as styles } from "../../lib/styles/gridStyles";

export interface OptionsTileProps {
  icon: string;
  title: string;
  btnText: string;
  btnAction: () => void;
}

interface Props {
  title: string;
  items: OptionsTileProps[];
}

const OptionTile = ({ item }: { item: OptionsTileProps }) => {
  const { icon, title, btnText, btnAction } = item;

  return (
    <Flex sx={styles.tile}>
      <Icon name={icon} color="samoyedWhite" width={"80px"} height={"80px"} />
      <Text as="h3" text="h3" sx={styles.tileText}>
        {title}
      </Text>
      <Button variant="secondary" sx={styles.tileButton} onClick={btnAction}>
        {btnText}
      </Button>
    </Flex>
  );
};

function OptionsGrid({ title, items }: Props) {
  return (
    <Box sx={styles.mainBox}>
      <Text as="h2" text="h2" sx={styles.title}>
        {title}
      </Text>
      <Flex sx={styles.gridFlex}>
        {items.map(item => (
          <OptionTile item={item} />
        ))}
      </Flex>
    </Box>
  );
}

export default OptionsGrid;
